<template>
  <div>
    <Toolbar class="d-flex justify-content-end py-2 px-2 sticky-top bg-white flex-wrap">
      <div slot="right">
        <el-button @click="request()">
          <i class="el-icon-s-operation d-flex justify-content-center" />
          <span>{{ $t('general.request') }}</span>
        </el-button>
        <el-button @click="add()">
          <i class="el-icon-circle-plus d-flex justify-content-center" />
          <span>{{ $t('general.add') }}</span>
        </el-button>
      </div>
    </Toolbar>
    <div class="pt-4">
      <transition-group name="fade">
        <QCVTextureCard
          v-for="(items, index) in cards"
          :key="'t' + index"
          ref="cards"
          v-model="cards[index]"
          :show-remove-button="cards.length > 1"
          class="m-2"
          :ind="index"
          @delete="cardDelete(index)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Toolbar from '../../components/mixer/Toolbar';
import QCVTextureCard from '../../components/mixer/QCVTextureCard';
import RequestMixerModal from '../../components/modals/RequestMixerModal';
export default {
  name: 'QCVMixerView',
  components: { QCVTextureCard, Toolbar },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      cards: [
        [
          {
            id: 1,
            color: { name: 'QCV uni red', hex: '#9b2423', code: 'D383' },
            amount: 90,
          },
          {
            id: 2,
            color: { name: 'QCV uni navy blue', hex: '#0f3052', code: 'D40' },
            amount: 10,
          },
        ],
      ],
    };
  },
  computed: {},
  methods: {
    add() {
      if (this.cards.length < 5) {
        this.cards.unshift([
          {
            id: this.cards.length + 1,
            color: { name: 'ACV uni red', hex: '#9b2423' },
            amount: 90,
          },
          {
            id: this.cards.length + 2,
            color: { name: 'QCV uni navy blue', hex: '#0f3052', code: 'RAL5026' },
            amount: 10,
          },
        ]);
      }
    },
    cardDelete(index) {
      this.cards.splice(index, 1);
    },
    request() {
      let mixerData = [];
      for (let i = 0; i < this.cards.length; i++) {
        let canvas = this.$refs.cards[i].$refs.canvas;
        let dataURL = canvas.toDataURL();

        mixerData.push({ image: dataURL, colors: this.cards[i], checked: false });
      }
      this.$modal.show(
        RequestMixerModal,
        { mixerData, type: 'qcv' },
        { height: 'auto', width: '90%', minWidth: 400, maxWidth: 1000 }
      );
    },
  },
};
</script>
